/* eslint-disable react/prop-types */
import React from 'react';
import { Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const MarkDownBox = function MarkDownBox({ text }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px' }}>
      <Typography>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
      </Typography>
    </div>
  );
};

export default MarkDownBox;
